import { ShoppingBag, Mail, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Marketplace() {
  return (
    <main className="pt-24 pb-20 min-h-screen" data-testid="marketplace-page">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="mb-12">
          <p className="font-accent text-xs tracking-[0.3em] text-gold/60 mb-2">PREMIUM ACCESS</p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white/95">
            AlfredWine Marketplace
          </h1>
          <p className="font-body text-base text-white/50 mt-4 max-w-2xl">
            Browse exclusive primeurs, rare bottles and allocations curated for Premium and Business members.
          </p>
        </div>

        <div className="glass-card rounded-sm p-12 text-center" data-testid="marketplace-coming-soon">
          <ShoppingBag className="w-10 h-10 text-gold/70 mx-auto mb-5" />
          <p className="font-accent text-xs tracking-[0.3em] text-gold/60 mb-3">COMING SOON</p>
          <h2 className="font-display text-2xl text-white/90 mb-3">
            The shop is opening its doors
          </h2>
          <p className="font-body text-sm text-white/50 max-w-md mx-auto mb-8 leading-relaxed">
            We're curating the inaugural selection with our partner estates.
            Members will be notified by email when the first drops go live.
          </p>
          <div className="flex items-center justify-center gap-3">
            <a href="mailto:tastings@alfredwines.com?subject=Marketplace%20Interest">
              <Button data-testid="marketplace-notify-btn" className="bg-merlot hover:bg-merlot-light text-white gap-2">
                <Mail className="w-4 h-4" /> Request Early Access
              </Button>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10" data-testid="marketplace-preview">
          {[
            { title: "Exclusive Wines", desc: "Secure allocations of the latest vintages — 24h before public release." },
            { title: "Private Collectors", desc: "Mature bottles from our partner cellars, fully provenance-verified." },
            { title: "Members Only", desc: "Exclusive prices negotiated directly with producers." },
          ].map((x) => (
            <div key={x.title} className="glass-card rounded-sm p-5">
              <div className="flex items-center gap-2 mb-2">
                <Tag className="w-4 h-4 text-gold/70" />
                <h3 className="font-display text-lg text-white/90">{x.title}</h3>
              </div>
              <p className="font-body text-sm text-white/50 leading-relaxed">{x.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
